var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7041 14.3943C25.2383 14.4129 25.7771 14.4756 26.3148 14.5847M20.6814 33.825C23.6984 34.9816 27.1521 34.6611 29.9287 32.8646C30.1982 32.6904 30.3631 32.392 30.3631 32.0714V31.2945C30.3631 28.6259 27.7827 28.0023 24.3604 28.0023C20.938 28.0023 18.3577 28.6259 18.3577 31.2945V32.5673M14.8947 27.0407C14.3245 25.1072 14.3396 22.9809 15.07 20.937C16.1756 17.8445 18.6642 15.645 21.5918 14.7856M35.604 31.8984L44.2626 39.7302C45.5887 40.9298 45.641 42.9957 44.3764 44.2592C43.1117 45.5238 41.0458 45.4716 39.8473 44.1454L33.7575 37.4134M26.8687 23.3618C26.2184 24.8238 24.5845 25.4451 23.2177 24.7507C21.8508 24.0551 21.2702 22.3062 21.9205 20.8441C22.5708 19.382 24.2047 18.7607 25.5716 19.4552C26.9384 20.1508 27.5191 21.8997 26.8687 23.3618ZM33.9783 14.6233C39.2912 19.9362 39.2912 28.5501 33.9783 33.863C28.6654 39.1759 20.0515 39.1759 14.7386 33.863C9.42568 28.5501 9.42568 19.9362 14.7386 14.6233C20.0515 9.31045 28.6654 9.31045 33.9783 14.6233Z",
    stroke: "#878686",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.53469c011b42cbb77d40f7b5821ecf67.svg";
export { ForwardRef as ReactComponent };